// MockPaperSpec — user-side configuration for one mock paper.
//
// Lives on CourseDraft.mockPapers[] (0-3 entries). One spec → one generated
// paper in IngestPackage.mockExamItems.papers[] with matching id.
//
// Decision (Session 19S §C-1):
//   - Required pastPaperRef when style is past_paper_strict/inspired.
//     Enforced via z.refine at the schema level so create-course form's
//     safeParse rejects invalid combinations early (rather than at ingest time).
//   - id pattern paper_[1-3] keeps cardinality bounded; ingest worker iterates
//     these and skips on missing.
//   - description is user-facing label ("First mock - timed" / etc.); UI shows
//     it on paper-picker cards. Optional.
import { z } from 'zod';
import { MockPaperStyleSchema, styleRequiresPastPaper } from './mock-paper-style.js';
export const MockPaperSpecSchema = z
    .object({
    /** paper_1 / paper_2 / paper_3. Bounded by mock-exam-view paper count limit. */
    id: z.string().regex(/^paper_[1-3]$/, 'mockPaper id must be paper_1/paper_2/paper_3'),
    style: MockPaperStyleSchema,
    /** Required when style is past_paper_strict/inspired. References PastPaper.id. */
    pastPaperRef: z.string().regex(/^[a-z][a-z0-9_-]*$/).optional(),
    /** Free-text label shown in mock-exam-view paper-picker. */
    description: z.string().max(80).optional(),
})
    .refine((spec) => !styleRequiresPastPaper(spec.style) || !!spec.pastPaperRef, {
    message: 'pastPaperRef is required when style is past_paper_strict or past_paper_inspired',
    path: ['pastPaperRef'],
});
//# sourceMappingURL=mock-paper-spec.js.map